//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const acceptList = ['json'];
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileList: [],
      strList: [],
    };
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('cancel', val);
        this.$nextTick(() => {
          this.fileList = [];
          this.strList = [];
        });
      },
    },
  },
  methods: {
    moveFile() {
      this.fileList = [];
      //   this.$emit('importFile', []);
      this.strList = [];
    },
    onUploadChange(evet, fileList) {
      if (!acceptList.includes(evet.name.split('.').pop())) {
        this.fileList = fileList.slice(-2, 1);
        this.$message.error(`仅支持上传${acceptList.join(',')}格式的文件`);
        return;
      }
      this.fileList = fileList.slice(-1);
      const reader = new FileReader();
      reader.readAsText(this.fileList[0].raw, 'UTF-8');
      reader.onload = (e) => {
        //   this.$emit('importFile', [e.target.result]);
        this.strList = [e.target.result];
      };
    },
    onUploadErr() {
      this.$message.error('文件导入失败');
    },
    handleClose() {
      this.visible = false;
    },
    async submit() {
      // 获取数据并验证
      let pressConfig = {};
      //   let modelConfig = {};
      try {
        pressConfig = JSON.parse(this.strList[0]);
      } catch (err) {
        console.log(err);
        this.$message.error('json文件格式错误');
        return;
      }
      const tips = [];
      try {
        JSON.parse(pressConfig.edit_json);
      } catch (err) {
        console.log(err);
        tips.push('模型json格式错误');
      }
      [
        // 'edit_process_desc',
        'edit_json',
        'edit_process_name',
        'module',
        'process_key',
      ].forEach((key) => {
        if (!Object.keys(pressConfig).includes(key)) {
          tips.push(`缺少配置参数:${key}`);
        }
      });
      if (tips.length) {
        tips.forEach((type) => {
          setTimeout(() => {
            this.$message.error(`导入文件${type}`);
          }, 10);
        });
        return;
      }
      // 新建
      try {
        await this.$request({
          url: this.$api.createEditProcess,
          data: {
            edit_process_name: pressConfig.edit_process_name,
            edit_json: pressConfig.edit_json,
            edit_process_desc: pressConfig.edit_process_desc || '',
            module: pressConfig.module,
            preset: pressConfig.preset,
            process_key: pressConfig.process_key,
            remark: pressConfig.remark || '',
            app_id: pressConfig.app_id,
            actions: pressConfig.actions || [],
            biz_type: pressConfig.biz_type,
          },
        });
        this.visible = false;
        this.$emit('refresh');
      } catch (err) {
        console.log(err);
      }
    },
  },
};
